<template>
    <div>
        <PullContainer ref="pullContainerRef"  :pullDownLoading="true" :pullDownLabel="true" @pullDownLoadingSuccess="pullDownLoadingSuccess">
            <template #container>
                <div class="public_container warehouse_container" v-loading="loading">
                    <div class="returnNavBar">
                        <ReturnNavBar title="返回" :isTitleNormal="true" :isAllFunctions="true"></ReturnNavBar>
                        <div class="mobile_head_operate" >
                            <van-popover v-model="headOperatePopoverShow" trigger="click" placement="bottom-end">
                                <ul class="head_operate_popover_list">
                                    <li v-for="item in headOperateActionsList" @click="handleClickHeadOperate(item)" v-if="warehouseId == '' && item.value == 'batch' ? false :true">
                                        <i :class="item.icon"></i> <span v-text="item.text"></span>
                                    </li>
                                </ul>
                                <template #reference>
                                    <span><i class="iconfont icon-a-tianjiamiaobian"></i></span>
                                </template>
                            </van-popover>
                        </div>
                    </div>
                    <div class="mobile_search">
                        <div class="mobile_search_input">
                            <van-search
                                    v-model="searchForm.keyword"
                                    placeholder="请输入查询内容"
                                    @clear="handleClickSearch"
                                    @search="handleClickSearch">
                                <template #right-icon>
                                    <i class="iconfont icon-tuodong" @click="sortRadioPicker = true"></i>
                                </template>
                            </van-search>
                        </div>

                        <div class="mobile_search_tab">
                            <div class="left">
                                <ul>
                                    <li @click="handleClickWarehouse({id:''})" :class="warehouseId == '' ? 'active' : ''"> 全部产品</li>
                                    <li @click="handleClickWarehouse(item)" v-for="item in warehouseList" v-text="item.name" :class="warehouseId == item.id ? 'active' : ''"></li>
                                </ul>
                            </div>
                            <div class="right">
                                <div class="box">
                                    <span @click="handleClickShowType('card')" :class="showType == 'card' ? 'active' : ''">卡片</span>
                                    <span @click="handleClickShowType('table')" :class="showType == 'table' ? 'active' : ''">表格</span>
                                </div>
                            </div>
                        </div>

                    </div>
                    <div class="product_container mobile_container" ref="product_container">
                        <div class="selected_number" ref="selected_number" v-if="isEnabledChecked">
                            <div>已选：<span>{{checked.length}}个</span></div>
                            <div class="cancel_btn" @click="handleClickCancelChecked">取消选择</div>
                        </div>

                        <div class="product_wrap" ref="product_wrap">
                            <template v-if="showType == 'card'">
                                <div class="product_card">
                                    <ul  v-infinite-scroll="onLoadList">
                                        <van-checkbox-group  v-model="checked" v-if="tableData.length>0">
                                            <li v-for="item in tableData" :class="isEnabledChecked ? '' : 'flex_js_wrap'">
                                                <div class="check_box" v-if="isEnabledChecked">
                                                    <van-checkbox icon-size="16px" v-model="item.checked" :name="item" shape="square"></van-checkbox>
                                                </div>
                                                <div class="content_text">
                                                    <div class="ellipsis" v-text="item.name"></div>
                                                    <p><span class="ellipsis" v-text="item.stocks.name"></span><span class="ellipsis" v-text="item.total_num"></span></p>
                                                </div>
                                                <div class="handle" v-if="!isEnabledChecked">
                                                    <span @click="handleRadioPicker = true;productInfo = item">更多操作</span>
                                                </div>
                                            </li>
                                        </van-checkbox-group>
                                        <van-empty description="暂无数据" v-else/>
                                    </ul>

                                </div>


                            </template>

                            <template v-else>
                                <van-checkbox-group  v-model="checked">
                                     <el-table class="custom_table" :data="tableData" :height="isEnabledChecked ? tableHeight - 32 : tableHeight" border ref="tableContainer" row-key="id" >
                                        <el-table-column v-if="isEnabledChecked" fixed="left" align="center"  width="40">
                                            <template #default="{ row }">
                                                <van-checkbox icon-size="16px" v-model="row.checked" :name="row" @change="" shape="square"></van-checkbox>
                                            </template>
                                        </el-table-column>
                                        <el-table-column label="产品名称" prop="name" show-overflow-tooltip width="196px"></el-table-column>
                                        <el-table-column label="所属仓库" prop="stocks" show-overflow-tooltip width="140px">
                                            <template #default="{ row }">
                                                <span  v-text="row.stocks ? row.stocks.name : ''"></span>
                                            </template>
                                        </el-table-column>
                                        <el-table-column label="库存数量" prop="total_num" show-overflow-tooltip width="100px"></el-table-column>
                                        <el-table-column label="操作" prop="handle" show-overflow-tooltip width="58px" fixed="right">
                                            <template #default="{ row }">
                                                <el-button type="text" @click="handleRadioPicker = true;productInfo = row">更多</el-button>
                                            </template>
                                        </el-table-column>
                                  </el-table>
                                </van-checkbox-group>
                            </template>

                        </div>

                    </div>
                    <!--批量操作产品-->
                    <div class="handle_footer" v-if="isEnabledChecked">
                        <van-tabbar  :safe-area-inset-bottom="true"   active-color="#646566">
                            <van-tabbar-item v-for="(item,key) in batchTabBarList" :key="key" @click="handleChangeBatchTabBar(item)">
                                <template #icon="props">
                                    <i class="iconfont" :class="item.icon"></i>
                                </template>
                                {{item.title}}
                            </van-tabbar-item>
                        </van-tabbar>
                    </div>

                    <FooterTabbar :tabBarList="tabBarList" :tabBarActive="tabBarActive"></FooterTabbar>
                    <!-- 排序-->
                    <van-overlay :custom-style="{ background: 'rgba(0, 0, 0, 0.3)' }"  z-index="1000" v-if="sortRadioPicker" :show="sortRadioPicker" @click="sortRadioPicker = false" >
                        <div class="custome_radio_option_wrap">
                            <ul class="radio_option_list">
                                <li v-for="item in sortList" class="radio_option_item"  @click="handleClickSortItem(item)"  v-text="item.name"></li>
                            </ul>
                            <div class="cancel_btn" @click="sortRadioPicker = false">取消</div>
                        </div>
                    </van-overlay>
                    <!--操作产品-->
                    <van-overlay :custom-style="{ background: 'rgba(0, 0, 0, 0.3)' }" z-index="1000" v-if="handleRadioPicker" :show="handleRadioPicker" @click="handleRadioPicker = false" >
                        <div class="custome_radio_option_wrap">
                            <ul class="radio_option_list">
                                <li v-for="item in handleItemList" class="radio_option_item"  @click="handleClickItem(item)"  v-text="item.name"></li>
                            </ul>
                            <div class="cancel_btn" @click="handleRadioPicker = false">取消</div>
                        </div>
                    </van-overlay>


                </div>
            </template>
        </PullContainer>
    </div>

</template>
<script>
import {stockProductList, stockList} from '@/api'
import { pagination } from "@/mixins";
import PullContainer from '@/components/mComponents/PullContainer.vue'
import ReturnNavBar from "@/components/mComponents/ReturnNavBar.vue";
import FooterTabbar from '@/components/mComponents/FooterTabbar.vue'
import {EventBus} from '@/utils/eventBus';
export default {
    name: 'warehouseManagement',
    components: {
        PullContainer,
        ReturnNavBar,
        FooterTabbar
    },
    data () {
        return {
            showType:'card', //table
            tabBarList:[
                {
                    icon:'icon-shouye',
                    activeIcon:'icon-shouyexuanzhong',
                    routerName:'InventoryManagement',
                    title:'首页'
                },
                {
                    icon:'icon-cangku2',
                    activeIcon:'icon-cangkuxuanzhong',
                    routerName:'WarehouseManagement',
                    title:'仓库管理'
                },
                {
                    icon:'icon-renwu_weixuanzhong',
                    activeIcon:'icon-renwu_xuanzhong',
                    routerName:'InventoryPending',
                    title:'出入库待办'
                },

            ],
            tabBarActive:1,
            headOperatePopoverShow: false,
            headOperateActionsList: [
                {value:"out", text: "出库", icon: "iconfont icon-chuku" },
                {value:"in", text: "入库", icon: "iconfont icon-ruku" },
                {value:"scan", text: "扫一扫", icon: "iconfont icon-saoyisao" },
                {value:"batch", text: "批量操作", icon: "iconfont icon-piliangcaozuo" },
            ],
            searchForm:{
                keyword:'',
                sort:''
            },
            sortRadioPicker:false,
            sortList:[
                {name:'升序排序',value:'asc'},
                {name:'降序排序',value:'desc'},
            ],
            handleItemList:[
                {name:'入库',value:'in'},
                {name:'出库',value:'out'},
                {name:'转移',value:'transfer'},
                {name:'详情',value:'detail'},
            ],
            checked:[],
            warehouseList:[],
            warehouseId:'',
            tableData:[],
            loading:false,
            isEnabledChecked:false, //是否开启选择
            handleRadioPicker:false,
            productInfo:null,
            batchTabBarList:[
                {
                    icon:'icon-chuku',
                    value:'batch_out',
                    title:'批量出库'
                },
                {
                    icon:'icon-ruku',
                    value:'batch_in',
                    title:'批量入库'
                },
                {
                    icon:'icon-huanhuo',
                    value:'batch_transfer',
                    title:'批量转移'
                },
            ],
            tableHeight:455
        }
    },
    mixins: [pagination],
    created() {
        EventBus.$on('warehouseUpdated', this.handleClickSearch);
        this.getStockList()
        this.getTableData()
        this.$nextTick(()=>{
            this.tableHeight = this.$refs.product_wrap ? this.$refs.product_wrap.offsetHeight - 5 : 455
        })
    },
    beforeDestroy() {
        EventBus.$off('warehouseUpdated', this.handleClickSearch);
    },
    mounted () {

    },
    methods: {
        pullDownLoadingSuccess(flag) {
            if (flag) {
                this.pullDownLoading = true
                this.handleClickSearch()
            }
        },
        handleClickHeadOperate(item) {
            if(item.value == 'batch'){
               this.isEnabledChecked = true
            }else if(item.value == 'in'){
                this.handleInWarehouseAdd()
            }else if(item.value == 'out'){
                this.handleOutWarehouseAdd()
            }else{

            }
            this.headOperatePopoverShow = false;
        },
        handleClickSearch(){
            this.pagination.pageNum = 1
            this.tableData =  []
            this.checked = []
            this.getTableData()
        },
        // 排序
        handleClickSortItem(item){
            this.searchForm.sort = item.value
            this.sortRadioPicker = false
            this.handleClickSearch()
        },
        // 切换展现方式
        handleClickShowType(type){
          this.showType = type
          if(type == 'table'){
              this.$nextTick(()=>{
                  const container = this.$refs.tableContainer.$el.querySelector('.el-table__body-wrapper'); // 获取 el-table 的根 DOM 元素
                  if (container) {
                      container.addEventListener('scroll', this.handleScroll);
                  }
              })
          }
        },
        // 选择仓库
        handleClickWarehouse(item){
          this.warehouseId = item.id
          this.isEnabledChecked = false
          this.handleClickSearch()
        },

        // 取消选择产品
        handleClickCancelChecked(){
            this.isEnabledChecked = false
            this.checked = []
        },
        // 点击操作单个产品
        handleClickItem(item){
          this.handleRadioPicker = false
            if(item.value == 'in'){
                this.handleInWarehouseAdd([this.productInfo])
            }else if(item.value == 'out'){
                this.handleOutWarehouseAdd([this.productInfo])
            }else if(item.value == 'transfer'){
                this.handleProductTransferAdd([this.productInfo])
            }else if(item.value == 'detail'){

            }
        },
        // 批量操作
        handleChangeBatchTabBar(item){
            if(this.checked.length == 0) return this.$toast('请选择产品')
            if(item.value == 'batch_in'){
                this.handleInWarehouseAdd(this.checked)
            }else if(item.value == 'batch_out'){
                this.handleOutWarehouseAdd(this.checked)
            }else if(item.value == 'batch_transfer'){
                this.handleProductTransferAdd(this.checked)
            }
        },
        // 普通入库
        handleInWarehouseAdd(data){
            if(data && data.length) {
                let selectedList = JSON.parse(JSON.stringify(data))
                if (!this.warehouseId) {
                    selectedList.forEach((item) => {
                        item.stock_id = ''
                    })
                }
                this.$store.dispatch("inventoryProductData", selectedList);
            }
            this.$router.push({
                name:'InWarehouseAdd',
                params: {
                    from:"warehouse",
                    isPush: true
                }
            })
        },
        // 普通出库
        handleOutWarehouseAdd(data){
            if(data && data.length){
                let selectedList = JSON.parse(JSON.stringify(data))
                if(!this.warehouseId){
                    selectedList.forEach((item)=>{
                        item.stock_id = ''
                    })
                }
                this.$store.dispatch("inventoryProductData", selectedList);
            }

            this.$router.push({
                name:'OutWarehouseAdd',
                params: {
                    from:"warehouse",
                    isPush: true
                }
            })
        },
        // 转移
        handleProductTransferAdd(data){
            this.$store.dispatch("inventoryProductData", data);
            this.$router.push({
                name:'productTransfer',
                query:{
                    warehouse_id:data[0].stock_id,
                }
            })
        },

        // 获取仓库列表
        getStockList(){
            stockList({}).then(res => {
                if (res.code === 200) {
                    this.warehouseList = res.data
                }
            })
        },

        handleScroll() {
            const container = this.$refs.tableContainer.$el.querySelector('.el-table__body-wrapper');
            if (container.scrollTop + container.clientHeight >= container.scrollHeight) {
                this.onLoadList();
            }
        },
        // 加载更多
        onLoadList() {
            if(this.pagination.total == this.tableData.length){
                return false
            }
            if(this.loading == false){
                this.getTableData();
            }
        },
        getTableData(){
            this.loading = true
            let postData = {
                page: this.pagination.pageNum,
                pageSize:  10,//this.pagination.pageSize
                id:this.warehouseId ? this.warehouseId : '',
                keyword:this.searchForm.keyword,
                sort:this.searchForm.sort
            }
            stockProductList(postData).then(res => {
                if (res.code === 200) {
                    let {list,total} = res.data
                    this.tableData = this.tableData.concat(list)
                    this.pagination.total = total
                    this.pagination.pageNum++;
                    this.loading = false
                    if(this.pullDownLoading){
                        this.pullDownLoading = false;
                        this.$refs.pullContainerRef.pullDownLoadingEnd('刷新成功');
                    }
                }

            })
        },
    },

}
</script>

<style lang="scss" scoped>
@import "@/styles/m_style/inventory_management.scss";
 .handle_footer{
        position: absolute;
        width: 100%;
        bottom: 0;
        left: 0;
        z-index: 1000;
    }
</style>
